<div class="otp-container" [ngClass]="{'!w-[327px] !p-6': bp.isCompact()}">
  <div class="heading-title">
    <span class="title-text">Verificación</span>
    <span class="body-text"
      >Ingresa el código de 6 dígitos que fue enviado a tu correo electrónico.
      Asegúrate de revisar todas las bandejas.</span
    >
  </div>
  <div class="flex flex-col items-center gap-5 mb-5">
    <div class="flex flex-row gap-1">
      <mg-input
        [ngClass]="{'error-code': isErrorCode,
          'active-input' : code[0]
        }"
        maxLength="1"
        [value]="code[0]"
        (input)="onInputChange(0, $event)"
        (paste)="onPaste(0, $event)"
        (keydown)="onKeydown(0, $event)"
      ></mg-input>
      <mg-input
        [ngClass]="{'error-code': isErrorCode,
          'active-input' : code[1]}"
        maxLength="1"
        [value]="code[1]"
        (input)="onInputChange(1, $event)"
        (paste)="onPaste(1, $event)"
        (keydown)="onKeydown(1, $event)"
      ></mg-input>
      <mg-input
        [ngClass]="{'error-code': isErrorCode,
          'active-input' : code[2]}"
        maxLength="1"
        [value]="code[2]"
        (input)="onInputChange(2, $event)"
        (paste)="onPaste(2, $event)"
        (keydown)="onKeydown(2, $event)"
      ></mg-input>
      <mg-input
        [ngClass]="{'error-code': isErrorCode,
          'active-input' : code[3]}"
        maxLength="1"
        [value]="code[3]"
        (input)="onInputChange(3, $event)"
        (paste)="onPaste(3, $event)"
        (keydown)="onKeydown(3, $event)"
      ></mg-input>
      <mg-input
        [ngClass]="{'error-code': isErrorCode,
          'active-input' : code[4]}"
        maxLength="1"
        [value]="code[4]"
        (input)="onInputChange(4, $event)"
        (paste)="onPaste(4, $event)"
        (keydown)="onKeydown(4, $event)"
      ></mg-input>
      <mg-input
        [ngClass]="{'error-code': isErrorCode,
          'active-input' : code[5]}"
        maxLength="1"
        [value]="code[5]"
        (input)="onInputChange(5, $event)"
        (paste)="onPaste(5, $event)"
        (keydown)="onKeydown(5, $event)"
        (keydown.enter)="onSubmit()"
      ></mg-input>
    </div>
    <p class="modal-content">
      <ng-container *ngIf="isErrorCode === true"
        ><span class="error-text"
          >El código no coincide. <strong>Intenta de nuevo</strong></span
        ><br /><br
      /></ng-container>
      <ng-container *ngIf="(countdown && !countdown?.finished); else resendCode"
        >Reenviar código en {{ countdown.m + ':' + countdown.s }}
        segundos</ng-container
      >
      <ng-template #resendCode>
        <span class="body-text"
          >¿No recibiste el código?
          <a class="text-link" (click)="onRequestCode()" (keypress.enter)="onRequestCode()" (keypress.space)="onRequestCode()"
            >Solicítalo de nuevo</a
          ></span
        >
      </ng-template>
    </p>
  </div>
  <div class="buttons-container">
    <mg-button
      [loading]="loading"
      class="w-full"
      (click)="onSubmit()"
      [disabled]="!isFullCode()"
      >Validar</mg-button
    >
    <span routerLink="../login" class="cancel-label">Cancelar</span>
  </div>
</div>
